module.exports = __webpack_public_path__ + "static/media/no-voucher-wallet.5846960e.svg";